<template lang="html">
  <div class="stitle-wrapper">
    <span class="yellow-line"></span>
    <span class="title-content" :class="{'title-margin': small}"><slot></slot></span>
    <span v-if="mode" :class="`title-icon icon-${mode}`"></span>
  </div>
</template>

<script>
export default {
  name: "stitle",
  props: {
    mode: {
      type: String,
      default(){
        return "";
      }
    },
    small: {
      type: Boolean,
      default(){
        return true;
      }
    },

  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import "~@/common/stylus/mixin.styl";
.stitle-wrapper
  position: relative
  display: flex
  align-items: center
  .yellow-line
    width: 0.03rem
    height: 0.24rem
    border-radius: 0.02rem
    background-color: #D2BE68
  .title-content
    // margin-left: 7px
    font-size: 0.18rem
    color: #F8F7F0
    &.title-margin
      margin-left: 0.07rem
  .title-icon
    position: absolute
    right: 0
    top: 50%
    transform: translate(0, -50%)
    display: inline-block
    background-repeat: no-repeat
    background-size: 100% 100%
    &.icon-chat
      width: 0.26rem
      height: 0.22rem
      bg-image("~@/images/index/icon-chat")
    &.icon-manage
      width: 0.22rem
      height: 0.23rem
      bg-image("~@/images/index/icon-manage")
    &.icon-trade
      width: 0.28rem
      height: 0.28rem
      bg-image("~@/images/index/icon-trade")
    &.icon-pay
      width: 0.25rem
      height: 0.25rem
      bg-image("~@/images/index/icon-pay")
</style>
